import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useNavigate } from 'react-router-dom';
import { Pagination, Autoplay } from 'swiper/modules';
import LatestProjectImg1 from "../assets/images/home/latest-project-img1.jpg"
import LatestProjectImg2 from "../assets/images/home/latest-project-img2.jpg"
import LatestProjectImg3 from "../assets/images/home/latest-project-img3.jpg"
import LatestProjectImg4 from "../assets/images/home/latest-project-img4.jpg"
import LatestProjectImg5 from "../assets/images/home/latest-project-img5.jpg"
import LatestProjectImg6 from "../assets/images/home/latest-project-img6.jpg"
import LatestProjectImg7 from "../assets/images/home/latest-project-img7.jpg"
import ClientsSaySlider from '../component/ClientsSaySlider';
import LatestBlog from '../component/LatestBlog';
import Footer from '../component/Footer';
import Loader from '../component/Loader';
import FixHeader from '../component/FixHeader';



const Project1 = () => {
    const navigate = useNavigate()
    return (
        <>
            <Loader />
            <FixHeader />
            {/* <!-- ====================================== Project Section One ===================================== --> */}
            <section className="section-breadcrumb-img" id="project-section-one">
                <div className="container breadcrumb-main">
                    <h1 className="about-h1-text" data-aos="fade-down">Projects</h1>
                    <ul className="breadcrumb-list about-breadcrumb" data-aos="fade-up">
                        <li className="line-slash" onClick={() => navigate("/")}>Home</li>
                        <li className="line-slash" onClick={() => navigate("/Project1")}>Projects</li>
                        <li className="active-breadcrumb" onClick={() => navigate("/Project1")}>Projects 1</li>
                    </ul>
                </div>
            </section>
            {/* <!-- ====================================== Project Section Two ===================================== --> */}
            <section className="about-section-two">
                <div className="container">
                    <h2 className="section-heading-text latestProjects-heading" data-aos="fade-up">
                        <span>Content Writing</span> Projects
                    </h2>
                    <p className="section-sub-text pharetra urna" data-aos="fade-up">Hendrerit facilisi habitasse arcu urna
                        bibendum. Cursus in mattis nunc pretium amet dignissim.</p>
                </div>
                <div className="swiper-wrapper projectSwiper-wrapper">
                    <Swiper
                        className="projectSwiper"
                        spaceBetween={30}
                        loop={true}
                        speed={1600}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            991: {
                                slidesPerView: 5,
                                spaceBetween: 20,
                            },
                            575: {
                                slidesPerView: 3,
                                spaceBetween: 20,
                            },
                            320: {
                                slidesPerView: 2,
                                spaceBetween: 12,
                                centeredSlides: true,
                            },
                        }}
                        modules={[Autoplay]}
                    >
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/ProjectDetails1")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg1} alt="latest-project-img1" />
                                        <img src={LatestProjectImg1} alt="latest-project-img1" />
                                    </div>
                                    <h2>Homely Real Estate</h2>
                                    <h3>Web Copy Writer</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/ProjectDetails2")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg2} alt="latest-project-img2" />
                                        <img src={LatestProjectImg2} alt="latest-project-img2" />
                                    </div>
                                    <h2>Crypti App</h2>
                                    <h3>Video Script Writer</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/ProjectDetails3")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg3} alt="latest-project-img3" />
                                        <img src={LatestProjectImg3} alt="latest-project-img3" />
                                    </div>
                                    <h2>24Times News</h2>
                                    <h3>Blog Content Writer</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/ProjectDetails1")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg4} alt="latest-project-img4" />
                                        <img src={LatestProjectImg4} alt="latest-project-img4" />
                                    </div>
                                    <h2>Mobiza Mobile</h2>
                                    <h3>Digital Copy Writer</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/ProjectDetails2")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg5} alt="latest-project-img5" />
                                        <img src={LatestProjectImg5} alt="latest-project-img5" />
                                    </div>
                                    <h2>Jecky Grocery</h2>
                                    <h3>Brochure Copy Writer</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/ProjectDetails3")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg6} alt="latest-project-img6" />
                                        <img src={LatestProjectImg6} alt="latest-project-img6" />
                                    </div>
                                    <h2>Technical Writing</h2>
                                    <h3>Fluency</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/ProjectDetails1")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg7} alt="latest-project-img7" />
                                        <img src={LatestProjectImg7} alt="latest-project-img7" />
                                    </div>
                                    <h2>Blogging SEO</h2>
                                    <h3>Writer</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>

                <div className="swiper-wrapper overflow-hidden">
                    <Swiper
                        className="projectSwiper2"
                        spaceBetween={30}
                        loop={true}
                        speed={1600}
                        // direction={horizontal}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                            reverseDirection: true,
                        }}
                        breakpoints={{
                            991: {
                                slidesPerView: 5,
                                spaceBetween: 20,
                            },
                            575: {
                                slidesPerView: 3,
                                spaceBetween: 20,
                            },
                            320: {
                                slidesPerView: 2,
                                spaceBetween: 12,
                                centeredSlides: true,
                            },
                        }}
                        modules={[Autoplay]}
                    >
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/ProjectDetails1")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg1} alt="latest-project-img1" />
                                        <img src={LatestProjectImg1} alt="latest-project-img1" />
                                    </div>
                                    <h2>Homely Real Estate</h2>
                                    <h3>Web Copy Writer</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/ProjectDetails2")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg2} alt="latest-project-img2" />
                                        <img src={LatestProjectImg2} alt="latest-project-img2" />
                                    </div>
                                    <h2>Crypti App</h2>
                                    <h3>Video Script Writer</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/ProjectDetails2")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg3} alt="latest-project-img3" />
                                        <img src={LatestProjectImg3} alt="latest-project-img3" />
                                    </div>
                                    <h2>24Times News</h2>
                                    <h3>Blog Content Writer</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/ProjectDetails3")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg4} alt="latest-project-img4" />
                                        <img src={LatestProjectImg4} alt="latest-project-img4" />
                                    </div>
                                    <h2>Mobiza Mobile</h2>
                                    <h3>Digital Copy Writer</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/ProjectDetails1")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg5} alt="latest-project-img5" />
                                        <img src={LatestProjectImg5} alt="latest-project-img5" />
                                    </div>
                                    <h2>Jecky Grocery</h2>
                                    <h3>Brochure Copy Writer</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/ProjectDetails2")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg6} alt="latest-project-img6" />
                                        <img src={LatestProjectImg6} alt="latest-project-img6" />
                                    </div>
                                    <h2>Technical Writing</h2>
                                    <h3>Fluency</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/ProjectDetails3")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg7} alt="latest-project-img7" />
                                        <img src={LatestProjectImg7} alt="latest-project-img7" />
                                    </div>
                                    <h2>Blogging SEO</h2>
                                    <h3>Writer</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </section>
            <ClientsSaySlider />
            <LatestBlog />
            <Footer />
        </>
    )
}

export default Project1